import { animatePopupIn } from '../../functions/animation.js';
import { createCloseButton } from '../../elements/popup/closeButton.js';
import Overlay from '../../classes/overlay.js';

// showpopup.js
export function showPopup(input, kirbycontent) {

    var doekwidth = doek.element.offsetWidth / 2;
    var doekheight = doek.element.offsetHeight / 2;
     
    var popup = document.createElement('div');
    popup.id = 'popup';
    popup.className = 'table';

    var popupwidth = 2200; 
    var popupheight = 1500;

    if (window.innerWidth <= 1000) { // mobiel
        var popupwidth = 1960; 
        var popupheight = 700;
    } 
    popup.style.width = popupwidth + "px";
    popup.style.height = popupheight + "px";
    popup.style.top = doekheight - (popupheight / 2) + "px";
    popup.style.left = doekwidth - (popupwidth / 2) + "px";

    var over = new Overlay;

    doek.element.appendChild(popup);
    animatePopupIn(popup);
    createCloseButton(popup);
  
    var info = document.createElement('div');
    info.className = 'info';

    // 1. Injecteer de via PHP (kt()) meegegeven HTML
    info.innerHTML = kirbycontent;

    // 2. Converteer 'Reflectievragen' naar een accordeon
    formatReflectievragen(info);

    popup.appendChild(info);
    createCloseButton(popup);
};

// Functie die 'Reflectievragen' opspoort en omzet naar knop + uitklapper
function formatReflectievragen(container) {
    const elements = container.querySelectorAll('p, strong, h2, h3, h4');

    elements.forEach(el => {
        const cleanText = el.textContent.trim();

        if (cleanText.startsWith('Reflectievragen')) {
            // Maak de knop
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'reflectievragen-btn';
            btn.innerText = 'Reflectievragen';

            // Maak de uitklapper
            const uitklapper = document.createElement('div');
            uitklapper.className = 'uitklapper';

            // Verwijder het woord 'Reflectievragen' uit het eerste element
            let contentHTML = el.innerHTML.replace(/^(\s*<[^>]+>)*\s*Reflectievragen\s*[-–:]?\s*/i, '');
            
            if (contentHTML.trim() !== '') {
                const p = document.createElement('p');
                p.innerHTML = contentHTML;
                uitklapper.appendChild(p);
            }

            // Trek alle opvolgende elementen (zoals <ul> met vragen) IN de uitklapper
            let nextEl = el.nextElementSibling;
            while (nextEl) {
                if (['H1', 'H2', 'H3'].includes(nextEl.tagName)) break;
                
                const toMove = nextEl;
                nextEl = nextEl.nextElementSibling;
                uitklapper.appendChild(toMove);
            }

            // Vervang de originele elementen door knop + uitklapper
            el.parentNode.insertBefore(btn, el);
            el.parentNode.insertBefore(uitklapper, el);
            el.remove();
        }
    });
}